import {
    getSelectBudgetDrawing,
    saveOrUpdateBudgetDrawing,
    startCompleteDrawing,
    previewPackagedDrawingPdf,
    quoteGoodsDetail,
    getSignLinkUrl,
    forcedWithdrawal,
    reUploadDrawer
} from '@/services/order'
import {Button, message, Space, Anchor, Spin} from 'antd'
import { useEffect, useRef, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import {SBack, SDrawerOrModal, SGeneralForms, SMessage, SAlert} from 'shj-components'
import { useFileUrlPrefix } from 'shj-utils'
import styles from '../../index.module.less'
import drawingManagementConfig from './config'
import { DrawingManagementParentType, DrawingManagementChildType, anchorList } from './index.d'
import {isArray} from "lodash-es";
import QRcodeModal from "@/components/QRcodeModal";

export default function DrawingManagement() {
  const { id, orderId } = useParams() // 报价商品id
  const [spinning, setSpinning] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [open, setOpen] = useState(false)
  const [imagePrefix] = useFileUrlPrefix()
  const [pdfUrl, setPdfUrl] = useState('')
  const [status, setStatus] = useState('')
  const formRef = useRef<any>()
  const [activeAnchor, setActiveAnchor] = useState('drawing-desc')
  const containerRef = useRef<HTMLDivElement>(null)
  const [pageLoading, setPageLoading] = useState(false)
  const [frozenFlag, setFrozenFlag] = useState('')
  const [qrVisible, setQrVisible] = useState(false)
  const [btnQRLoading, setBtnQRLoading] = useState(false)
  const [quoteGoodsDetailData, setQuoteGoodsDetailData] = useState<any>({})
  const [signLink, setSignLink] = useState('')
  const [forceWithdrawalLoading, setForceWithdrawalLoading] = useState(false)

  useEffect(() => {
    // 查询图纸
    getData()
    statusFn()
  }, [])

  // 监听滚动更新锚点
  useEffect(() => {
    const handleScroll = () => {
      const scrollContainer = containerRef.current
      if (!scrollContainer) return

      // 获取所有锚点
      const sections = document.querySelectorAll('[id^="drawing-"]')

      // 检查是否滚动到底部
      const isBottom =
        scrollContainer.scrollHeight - scrollContainer.scrollTop <= scrollContainer.clientHeight

      // 如果滚动到底部，则设置锚点为源文件
      if (isBottom) {
        setActiveAnchor('drawing-source')
        return
      }

      // 遍历所有锚点，找到当前锚点
      sections.forEach(section => {
        const element = section as HTMLElement
        const rect = element.getBoundingClientRect()
        // 判断距离，如果锚点在可视区域内，则设置为当前锚点
        if (rect.top <= 350) {
          setActiveAnchor(element.id)
        }
      })
    }

    // 使用 containerRef 作为滚动容器
    const scrollContainer = containerRef.current
    if (scrollContainer) {
      scrollContainer.addEventListener('scroll', handleScroll, { passive: true })

      // 初始化时执行一次
      handleScroll()

      return () => {
        scrollContainer.removeEventListener('scroll', handleScroll)
      }
    }
  }, [])

  // 获取整装图纸审核状态
  const statusFn = () => {
    quoteGoodsDetail(id).then((res: any) => {
      console.log(res)
      setFrozenFlag((res?.frozenFlag === true || res?.frozenFlag === false) ? String(res?.frozenFlag) : '')
      setStatus(res.overallDrawingAuditStatus)
      setQuoteGoodsDetailData(res||{})
    })
  }

  // 获取图纸信息
  const getData = async () => {
    setPageLoading(true)
    getSelectBudgetDrawing({
      quoteGoodsId: id,
    })
      .then((res: any) => {
        // 转换数组数据为表单值
        const formattedData = res.reduce(
          (acc, item) => {
            const { nameCode, urlList } = item

            // 转换每个 URL 为文件对象
            const fileList = urlList.map((url, index) => ({
              uid: `${nameCode}-${index}`,
              status: 'done',
              url: url,
              thumbUrl: url,
              name: url.split('/').pop(),
              response: {
                data: { fileUrl: url }, // 保持与上传时的数据结构一致
              },
            }))

            acc[nameCode] = fileList
            return acc
          },
          {} as Record<string, any>
        )

        // 使用 formRef 设置表单值
        formRef.current?.onFormRef().setFieldsValue(formattedData)
      })
      .finally(() => {
        setPageLoading(false)
      })
  }

  // 下载图纸
  const downloadImage = async () => {
    const formValues = formRef.current?.onFormRef().getFieldsValue()

    // 将对象转换为URL数组
    const urls = Object.values(formValues)
      .flat()
      .map((item: any) => item && item.response?.data?.fileUrl)
      .filter(Boolean)

    if (!urls.length) {
      message.warning('没有可下载的内容')
      return
    }

    // 下载所有图片
    const requests = urls.map(url => {
      return fetch(`${url}?response-content-type=application/octet-stream`)
        .then(response => response.blob())
        .then(blob => {
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = url.split('/').pop()
          link.click()
          window.URL.revokeObjectURL(link.href)
        })
    })

    await Promise.all(requests)
  }
  // 打开二维码弹窗
  const onQrCodeFn = () => {
      setBtnQRLoading(true)
      getSignLinkUrl({ esignContractId: quoteGoodsDetailData?.elecId||"" }).then((res: any) => {
         setSignLink(res?.message||"")
      }).finally(() => {
          setBtnQRLoading(false)
      })
  }
  const handleForceWithdraw = () => {
    SMessage.confirm({
        title: '强制撤回提醒',
        content: '请确认是否强制撤回客户签字？',
        onOk: () => {
            setForceWithdrawalLoading(true)
            forcedWithdrawal({ elecId: quoteGoodsDetailData?.elecId||"" })
                .then(() => {
                    setSignLink('')
                    message.success('强制撤回成功');
                    // 刷新状态
                    statusFn()
                })
                .catch(err => {
                    console.error('error forcedWithdrawal', err)
                })
                .finally(() => {
                    setForceWithdrawalLoading(false)
                })
        },
    })
  }

  // 客户签字
  const customerSign = () => {
    // 在请求之前先判断是否所有必填项已经填写
    const values = formRef.current?.onFormRef().getFieldsValue()
    // 获取所有必填项
    const requiredFields = Object.keys(DrawingManagementChildType).filter(
      key => DrawingManagementChildType[key].required
    )
    // 获取所有必填项中未填写的项
    const missingFields = requiredFields.filter(
      field => !values[field] || values[field].length === 0
    );
    // 定位未填锚点
    if(isArray(missingFields)&&missingFields.length>0){
        setCurrentAnchorFn(missingFields[0]);
    }
    // 如果存在未填写的项，则提示用户
    if (missingFields.length > 0) {
      const missingFieldsStr = missingFields
        .map(field => DrawingManagementChildType[field].name)
        .join('，')
      message.warning(`请先填写所有必填项：${missingFieldsStr}`)
      return
    }

    setSpinning(true)
    previewPackagedDrawingPdf({ orderId })
      .then((res: any) => {
        const url = imagePrefix + res.pdfUrl
        setPdfUrl(url)
        setSpinning(false)
        setOpen(true)
      })
      .finally(() => {
        setSpinning(false)
      })
  }

  const onSubmit = () => {
    setLoading(true)
    startCompleteDrawing({
      orderId,
    })
      .then(() => {
        message.success(`操作成功`)
        // 刷新状态
        statusFn()
        setLoading(false)
        setOpen(false)
      })
      .finally(() => {
        setLoading(false)
        setOpen(false)
      })
  }

  // 点击锚点
  const handleAnchorClick = (event: any, link: any) => {
    // 阻止默认行为
    event.preventDefault()
    setCurrentAnchorFn(link.href.split('#')[1]);
  }
  // 设置锚点
  const setCurrentAnchorFn = (anchorName: string) => {
    // 获取锚点元素
    const targetElement = document.getElementById(anchorName);
    if (targetElement) {
        // 滚动到锚点元素
        targetElement.scrollIntoView({behavior: 'smooth'})
        // 设置当前锚点
        setActiveAnchor(anchorName)
    }
  }
    // 获取图纸父级类型
  const getParentType = (type: string) => DrawingManagementParentType[type.split('-')[0]]

  // 获取图纸子级类型
  const getChildType = (type: string) => DrawingManagementChildType[type].name

  // 处理表单变化
  const handleFormChange = (_values, changedFields) => {
    // 初始化所有图纸类型
    const requestArr = Object.keys(DrawingManagementChildType).map(key => ({
      nameCode: key,
      name: getChildType(key),
      typeCode: key.split('-')[0],
      typeName: getParentType(key),
      urlList: [],
    }))

    // 遍历变化的字段，更新对应的 urlList
    Object.keys(changedFields).forEach(key => {
      if (changedFields[key]) {
        // 查找对应的图纸类型索引
        const index = requestArr.findIndex(item => item.nameCode === key)
        if (index !== -1) {
          // 更新 urlList
          requestArr[index].urlList = changedFields[key]
            .map((item: any) => item?.response?.data?.fileUrl)
            .filter(Boolean)
        }
      }
    })

    // 发送请求
    setPageLoading(true)
    saveOrUpdateBudgetDrawing({
      params: {
        quoteGoodsId: id,
      },
      data: requestArr,
    })
      .then(() => {
        message.success('内容已保存')
        setPageLoading(false)
      })
      .finally(() => {
        setPageLoading(false)
      })
  }

  const handleReUploadDrawer = async () => {
    SMessage.confirm({
      title: '提醒',
      content: '请确认是否重新上传图纸？确认后客户需重新签署《施工图纸确认合同》，才允许开工。',
      onOk: async () => {
        try {
          const res = await reUploadDrawer({
            orderId,
          })
          if (res) {
            // 查询图纸
            getData()
            statusFn()
          }
          return true;
        } catch (err) {
          return false;
        }
      },
    })
  }

  return (
    <Spin spinning={pageLoading} wrapperClassName={styles.spinWrapper}>
      <SBack
        title={'图纸管理'}
        level={2}
        extra={[
          <div className={styles.btns} style={{ display: 'flex', alignItems: 'center' }}>
            {!(status === 'COMPLETED' || status === 'RUNNING') ? (
              <>
                <div style={{ display: 'inline-block' }}>
                  <span className={styles.garyDesc} style={{ display: 'block' }}>
                    支持图片格式：JPEG/JPG/PNG，大小不超过10M{' '}
                  </span>
                  <span className={styles.garyDesc} style={{ display: 'block' }}>
                    支持源文件格式：DWG/DXF/DWT/CDR/SKP/MAX/3DS/MB/MA
                  </span>
                </div>
                <Space>
                  <Button onClick={downloadImage}>下载图纸</Button>
                  <Button disabled={frozenFlag === 'true'} type="primary" loading={spinning} onClick={customerSign}>
                    客户签字
                  </Button>
                </Space>
              </>
            ) : (
              <Space>
                <Button onClick={downloadImage}>下载图纸</Button>
                <Button disabled={true}>
                  {status === 'COMPLETED' ? '客户已确认' : '已发起客户签字'}
                </Button>
                  {
                      status === 'COMPLETED'? <>
                        <Button type="primary" onClick={handleReUploadDrawer}>再次上传图纸</Button>
                      </> : <>
                          <Button type="primary" onClick={()=>{
                              setQrVisible(true);
                              onQrCodeFn()
                          }}>查看二维码</Button>
                          <Button
                              type="primary"
                              onClick={handleForceWithdraw}
                              loading={forceWithdrawalLoading}
                          >
                              强制撤回
                          </Button>
                      </>
                  }
              </Space>
            )}
          </div>,
        ]}
        titleStyle={{ position: 'sticky', top: 0, zIndex: 999 }}
      >
        <div
          ref={containerRef}
          style={{
            display: 'flex',
            backgroundColor: '#fff',
            height: 'calc(100vh - 140px)',
            overflow: 'auto',
          }}
        >
          {/* 左侧锚点 */}
          <div
            style={{
              width: 150,
              marginRight: 20,
              position: 'sticky',
              top: 0,
              height: 'fit-content',
              alignSelf: 'flex-start',
            }}
          >
            <Anchor
              offsetTop={100}
              affix={false}
              getCurrentAnchor={() => `#${activeAnchor}`}
              onClick={handleAnchorClick}
              items={anchorList}
            />
          </div>

          {/* 右侧表单内容 */}
          <div
            style={{
              flex: 1,
              paddingRight: '20px',
            }}
          >
            {frozenFlag === 'true' ? <SAlert type="error">
              <span style={{ color: 'red'}}>当前订单中存在未结束的报价方案审核流程，无法修改图纸信息，请在流程结束后再试</span>
            </SAlert> : null}
            <SGeneralForms
              ref={formRef}
              layout={'vertical'}
              configs={drawingManagementConfig({ status, disabled: frozenFlag === 'true' })}
              formConfig={{
                onValuesChange: handleFormChange,
              }}
            />
          </div>
        </div>
        <SDrawerOrModal
          title={'预览图纸PDF'}
          mode="modal"
          open={open}
          width={1000}
          height={700}
          onCancel={() => {
            setOpen(false)
          }}
          antdProps={{
            footer: (
              <div>
                <Button
                  onClick={() => {
                    setOpen(false)
                  }}
                >
                  取消
                </Button>
                <Button
                  style={{ marginLeft: 15 }}
                  type="primary"
                  onClick={onSubmit}
                  loading={loading}
                  disabled={frozenFlag === 'true'}
                >
                  发起客户签字
                </Button>
              </div>
            ),
          }}
        >
          <div style={{ height: 700 }}>
            <embed src={pdfUrl} type="application/pdf" width="100%" height="100%" />
          </div>
        </SDrawerOrModal>
        {/*预览二维码*/}
        <QRcodeModal
            loading={btnQRLoading}
            visible={qrVisible}
            reloadFn={onQrCodeFn}
            onClose={() => {
                setQrVisible(false);
                setSignLink('');
            }}
            signLink={signLink}
        />
      </SBack>
    </Spin>
  )
}
